document.querySelectorAll('.mega-menu__item a').forEach(link => {
    if (link.textContent.trim() === 'Hidden') {
        link.closest('.mega-menu__item').style.display = 'none';
    }
});


// document.querySelectorAll('details[is="details-mega"]').forEach(details => {
//     details.addEventListener('toggle', () => {
//         const allMenuItems = document.querySelectorAll('li > a.menu__item');

//         if (details.hasAttribute('open')) {
//             // When this <details> has open=""
//             allMenuItems.forEach(link => {
//                 // Add class only to links NOT inside this details
//                 if (!details.contains(link)) {
//                     link.classList.add('menu-dim');
//                 }
//             });
//         } else {
//             // When open="" removed
//             allMenuItems.forEach(link => link.classList.remove('menu-dim'));
//         }
//     });
// });

// run after DOM ready
document.addEventListener('DOMContentLoaded', () => {
    const detailsSelector = 'details[is="details-mega"]';
    const liSelector = 'ul.flex.flex-wrap > li.inline-flex.items-center';
    const detailsElems = Array.from(document.querySelectorAll(detailsSelector));

    function updateDims() {
        const openDetails = Array.from(document.querySelectorAll(`${detailsSelector}[open]`)); // currently open details
        const listItems = Array.from(document.querySelectorAll(liSelector));

        if (openDetails.length === 0) {
            // no open menus -> remove dim from all
            listItems.forEach(li => li.classList.remove('menu-dim'));
            return;
        }

        // for each top-level li: if it doesn't contain any open <details>, add dim; otherwise remove it
        listItems.forEach(li => {
            const containsAnyOpen = openDetails.some(d => li.contains(d));
            if (containsAnyOpen) li.classList.remove('menu-dim');
            else li.classList.add('menu-dim');
        });
    }

    // listen to toggle on each details (fires when open attribute is added/removed)
    detailsElems.forEach(d => d.addEventListener('toggle', updateDims));

    // initialize state in case one was programmatically opened before event hookup
    updateDims();
});



document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 767) {
        const topbar = document.querySelector(".topbar__center");
        const firstDiv = topbar?.querySelector(".topbar__text");
        if (firstDiv && firstDiv.textContent.trim() === "") {
            firstDiv.remove();
        }
    }
});



document.querySelectorAll('.mega-menu__link--top').forEach(el => {
    el.innerHTML = `<span>${el.textContent.trim()}</span>`;
});



/** Hide if the accordion is emplty */
document.addEventListener("DOMContentLoaded", function () {
    // Run only on product-template pages
    if (!document.body.classList.contains("product-template")) return;

    // Select all h2 inside .accordion-details__summary
    const summaries = document.querySelectorAll(".accordion-details__summary h2");
    let hasEmpty = false;

    summaries.forEach((h2) => {
        if (!h2.textContent.trim()) {
            hasEmpty = true;
        }
    });

    // If any h2 is empty, hide .collapsible-tabs__wrapper
    if (hasEmpty) {
        const wrapper = document.querySelector(".collapsible-tabs__wrapper");
        if (wrapper) wrapper.style.display = "none";
    }
});
